export default function ConsentPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-12" data-testid="consent-policy-page">
      <div className="text-xs uppercase tracking-widest text-teal-700 font-semibold mb-2">Legal</div>
      <h1 className="text-4xl sm:text-5xl font-semibold text-slate-900 mb-8">Consent Policy</h1>
      <div className="prose prose-slate prose-sm max-w-none space-y-6 text-sm text-slate-600 leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">1. Why we collect consent</h2>
          <p>In line with RBI digital lending guidelines and the Digital Personal Data Protection Act, CarFin India (operated by Red Fort Capital Finance NBFC) collects explicit, purpose-specific, auditable consent before accessing any of your financial data.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">2. Credit bureau (CIBIL) consent</h2>
          <p>With your consent we pull your credit report from credit information companies (e.g. TransUnion CIBIL) solely for evaluating your loan application. Quick-eligibility soft checks do not affect your credit score. Your bureau data is retained only as long as required for the loan lifecycle and regulatory record-keeping.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">3. Account Aggregator (AA) consent</h2>
          <p>Bank-statement data is fetched only through the RBI-regulated Account Aggregator framework (Sahamati ecosystem) after you approve a consent artifact specifying purpose, data range and validity. You can revoke AA consent at any time through your Account Aggregator app.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">4. KYC consent</h2>
          <p>PAN, Aadhaar (where permitted, via OTP-based verification) and CKYC data are used solely for identity verification mandated under PML rules. Aadhaar numbers are never stored in full.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">5. Communication consent</h2>
          <p>By applying you consent to receiving loan-related SMS, email, WhatsApp and calls. Marketing communication is optional and can be opted out of at any time.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">6. Withdrawing consent & grievances</h2>
          <p>Write to grievance@carfin.com to withdraw consent or raise a complaint. Withdrawal of mandatory consents may prevent us from processing or continuing your loan. Grievances are acknowledged within 48 hours and resolved per our Fair Practices Code.</p>
        </section>
      </div>
    </div>
  );
}
